<template>
  <div class="sidebar">
    <el-menu
      class="sidebar-el-menu"
      :default-active="onRoutes"
      :collapse="collapse"
      background-color="#324157"
      text-color="#bfcbd9"
      active-text-color="#20a0ff"
      unique-opened
      :router="false"
      v-if="menus.length > 0"
    >
      <template v-for="(item, item_index) in menus">
        <template v-if="item.sub_menu.length > 0">
          <el-submenu :index="item.path_name" :key="item_index">
            <template slot="title">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.title }}</span>
            </template>
            <template v-for="(subItem, subItem_index) in item.sub_menu">
              <el-submenu
                v-if="subItem.type != 2 && subItem.sub_menu.length > 0"
                :index="subItem.path_name"
                :key="subItem_index"
              >
                <template slot="title">{{ subItem.title }}</template>
                <el-menu-item
                  v-for="(threeItem, i) in subItem.sub_menu"
                  :key="i"
                  :index="threeItem.path_name"
                  @click="toLink(threeItem)"
                  >{{ threeItem.title }}</el-menu-item
                >
              </el-submenu>
              <el-menu-item
                v-else
                :index="subItem.path_name"
                :key="subItem_index"
                @click="toLink(subItem)"
                >{{ subItem.title }}</el-menu-item
              >
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item
            :index="item.path_name"
            :key="item_index"
            @click="toLink(item)"
          >
            <i :class="item.icon"></i>
            <span slot="title">{{ item.title }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>

    <el-menu
      class="sidebar-el-menu"
      :default-active="onRoutes"
      :collapse="collapse"
      background-color="#324157"
      text-color="#bfcbd9"
      active-text-color="#20a0ff"
      unique-opened
      router
      v-else
    >
      <template v-for="item in items">
        <template v-if="item.subs">
          <el-submenu :index="item.index" :key="item.index">
            <template slot="title">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.title }}</span>
            </template>
            <template v-for="subItem in item.subs">
              <el-submenu
                v-if="subItem.subs"
                :index="subItem.index"
                :key="subItem.index"
              >
                <template slot="title">{{ subItem.title }}</template>
                <el-menu-item
                  v-for="(threeItem, i) in subItem.subs"
                  :key="i"
                  :index="threeItem.index"
                  >{{ threeItem.title }}</el-menu-item
                >
              </el-submenu>
              <el-menu-item
                v-else
                :index="subItem.index"
                :key="subItem.index"
                >{{ subItem.title }}</el-menu-item
              >
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item.index" :key="item.index">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.title }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
import bus from "../common/bus";
import http from "../../api/manageApiConfig";
export default {
  data() {
    return {
      collapse: false,
      items: [
        {
          icon: "el-icon-lx-calendar",
          index: "providerprescriptionmanage",
          title: "药房药方管理",
          subs: [
            // {
            //     index: 'providerlist',
            //     title: '药房机构列表'
            // },
            // {
            //     index: 'prescriptionlist',
            //     title: '常用方列表'
            // },
            // {
            //     index: 'categorieslist',
            //     title: '常用方分类列表'
            // },
            // {
            //     index: 'shmedicineslist',
            //     title: '药材列表'
            // },
            {
              index: "medicinemaintenance",
              title: "系统药材维护",
            },
            {
              index: "medicineslist",
              title: "药房药材列表",
            },
            {
              index: "medicinesorder",
              title: "药品订单列表",
            },
            // {
            //     index: 'productslist',
            //     title: '中成药列表'
            // }
          ],
        },
      ],
      menus: [],
    };
  },
  computed: {
    onRoutes() {
      return this.$route.path.replace("/", "");
    },
  },
  created() {
    if (this.getQueryString("t")) {
      this.getData();
    }
    // 通过 Event Bus 进行组件间通信，来折叠侧边栏
    bus.$on("collapse", (msg) => {
      this.collapse = msg;
      bus.$emit("collapse-content", msg);
    });
  },
  methods: {
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    getData() {
      let that = this;
      let params = {
        role_id: localStorage.getItem("ms_role"),
      };
      http.get("/admin/menus", { params: params }).then(function (res) {
        that.menus = res.data;
      });
    },
    toLink(item) {
      window.location.href =
        item.url + "?t=1" + `&token=` + localStorage.getItem("ms_token");
    },
  },
};
</script>

<style scoped>
.sidebar {
  display: block;
  position: absolute;
  left: 0;
  top: 70px;
  bottom: 0;
  overflow-y: scroll;
}
.sidebar::-webkit-scrollbar {
  width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
  width: 250px;
}
.sidebar > ul {
  height: 100%;
}
</style>
